import { cn } from "@/lib/utils";

const initialsOf = (name: string) =>
  name
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");

/** A coach's photo, or their initials on a primary tile when they have not uploaded one. */
export const CoachPhoto = ({ name, src, className }: { name: string; src: string | null; className?: string }) => {
  if (src) return <img src={src} alt="" className={cn("shrink-0 object-cover object-top", className)} />;
  return (
    <span
      aria-hidden
      className={cn("grid shrink-0 place-items-center bg-primary/15 font-semibold text-[var(--site-ink)]", className)}
    >
      {initialsOf(name)}
    </span>
  );
};
